module.exports = __webpack_public_path__ + "img/1523315724.c6f311ee.jpg";